import { useTranslation } from "react-i18next";
import { Section, Container, Card } from "../../ui";
import styles from "./Founder.module.css";

export function Founder() {
  const { t } = useTranslation("home");

  const quoteLines = t("founder.quoteLines", { returnObjects: true }) as string[];
  const pillars = t("pillars.items", { returnObjects: true }) as {
    letter: string; title: string; subtitle: string; problem: string; solution: string;
  }[];

  return (
    <Section variant="blue">
      <Container>
        <div className={styles.wrapper}>
          <div className={styles.founderGrid}>
            <div className={styles.imageWrapper}>
              <img
                src="/images/founder-eric.webp"
                alt={t("founder.imageAlt")}
                className={styles.image}
              />
              <span className={styles.caption}>{t("founder.caption")}</span>
            </div>
            <div className={styles.content}>
              <h2 className={styles.founderTitle}>{t("founder.title")}</h2>
              <blockquote className={styles.quote}>
                <p>
                  {quoteLines.map((line, i) => (
                    <span key={i} className={styles.qLine}>
                      {line}{" "}
                    </span>
                  ))}
                </p>
                <footer className={styles.signature}>
                  {t("founder.signature")}
                </footer>
              </blockquote>
            </div>
          </div>

          <div className={styles.pillarsSection}>
            <h2 className={styles.pillarsTitle}>{t("pillars.sectionTitle")}</h2>
            <div className={styles.pillarsGrid}>
              {pillars.map((pillar, i) => (
                <Card key={i} className={styles.pillarCard}>
                  <div className={styles.topBar} />
                  <div className={styles.pillarHeader}>
                    <span className={styles.letter}>{pillar.letter}</span>
                    <h3 className={styles.pillarName}>{pillar.title}</h3>
                    <span className={styles.pillarSubtitle}>
                      {pillar.subtitle}
                    </span>
                  </div>
                  <p className={styles.problem}>{pillar.problem}</p>
                  <p className={styles.solution}>{pillar.solution}</p>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
